import { useRef } from 'react';
import useEditorialMotion from '@/hooks/useEditorialMotion';

export default function Studio() {
  const ref = useRef<HTMLElement>(null);
  useEditorialMotion(ref);
  return (
    <section ref={ref} id="studio" className="bg-[#FAFAF8] py-20 md:py-36">
      <div className="px-4 md:px-10">
        <p data-m-fade className="text-[11px] md:text-[12px] tracking-wide text-black/50 mb-6 md:mb-8">05 / THE STUDIO</p>
        <h2 data-m-head className="font-normal tracking-[-0.045em] leading-[0.95] text-[40px] sm:text-[56px] lg:text-[80px] max-w-[1000px]">
          <span className="block overflow-hidden pb-[0.08em] -mb-[0.08em]"><span data-m-line className="block">Composed by nature.</span></span>
          <span className="block overflow-hidden pb-[0.08em] -mb-[0.08em]"><span data-m-line className="block">Finished by hand.</span></span>
        </h2>

        <div data-m-group className="mt-12 md:mt-20 grid grid-cols-1 md:grid-cols-[70fr_30fr] gap-10 md:gap-10 lg:gap-16 items-end">
          <div className="w-full aspect-[3/2] overflow-hidden" data-m-in="left" data-m-mask="left" data-m-dist="40" data-m-dur="0.9" data-m-ease="power2.inOut" data-m-at="0">
            <img
              src="https://public.readdy.ai/ai/img_res/sandbox/0a9d2030d78e6980171043cc5a230587/587ec097-3f6f-459e-9fda-bbab1d2fb4a2_ff-studio-wide.webp"
              width={1400}
              height={934}
              loading="lazy"
              decoding="async"
              alt="Florist hands composing a sculptural bouquet on a workbench — Fleur & Form"
              title="Floral craftsmanship at the Fleur & Form studio"
              data-m-zoom
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div className="flex flex-col min-w-0">
            <div className="w-full aspect-[4/5] overflow-hidden" data-m-in="right" data-m-dist="50" data-m-at="0.15">
              <img
                src="https://public.readdy.ai/ai/img_res/sandbox/0a9d2030d78e6980171043cc5a230587/587ec097-3f6f-459e-9fda-bbab1d2fb4a2_ff-studio-detail.webp"
                width={800}
                height={1000}
                loading="lazy"
                decoding="async"
                alt="Close-up of cut flower stems and petals — Fleur & Form"
                title="Botanical detail from the Fleur & Form studio"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <p data-m-in="up" data-m-dist="16" data-m-dur="0.6" data-m-at="0.45" className="text-[14px] md:text-[15px] leading-relaxed text-black/70 mt-8">
              We work with the natural character of every stem, creating arrangements that feel considered and beautifully imperfect.
            </p>
            <a data-m-in="up" data-m-dist="12" data-m-dur="0.5" data-m-at="0.55" href="mailto:hello@fleurandform.com" className="group self-start inline-flex items-center gap-1 mt-6 text-[13px] border-b border-black/30 hover:border-black pb-0.5 transition-colors whitespace-nowrap cursor-pointer">
              Visit the studio
              <span className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5">↗</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}